<template>
  <h2>
     <span>{{title}}</span>
     <slot></slot>
  </h2>

</template>

<script>

  export default {
    name: "title",
    props:{
        title: {
            type: String,
            default: () => (
              ''
            )
        },
    },
    data(){
      return{
        // dialogheaderVisible:false,
      }
    },
    methods:{

    }
  };
</script>

<style scoped>

    h2{
        position: relative;
        left: 0;
        display: flex;
        justify-content: space-between;
        padding-top: 6px;
        padding-bottom: 8px;
        height: 20px;
        align-items: center;
        line-height: 20px
    }
    h2>span{
        font-size:14px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:600;
        color:rgba(51,51,51,1);
        position: relative;
        padding-left: 20px;
    }
    h2>span::after{
        content: '';
        position: absolute;
        width:7px;
        height:12px;
        background:#93AADC;
        left: 0;
        top: 4px;
    }
    h2>div span{
        font-size:13px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(64,158,255,1);
    }
</style>
